export default __webpack_public_path__ + "static/media/copy.e744d2ac.svg";